import { InfoIcon } from 'foundations-assets';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { jsx as _jsx } from "react/jsx-runtime";
const SourceDescriptionIcon = ({
  description
}) => {
  return /*#__PURE__*/_jsx(Tooltip, {
    "data-test-id": "source-interpretation-description-tooltip",
    use: "longform",
    title: description,
    placement: "right",
    children: /*#__PURE__*/_jsx(IconHolder, {
      margin: "0",
      padding: "0",
      paddingInlineStart: "50",
      icon: () => /*#__PURE__*/_jsx(InfoIcon, {
        "data-test-id": "source-interpretation-description-icon",
        size: "200",
        color: "icon-core-subtle"
      })
    })
  });
};
export default SourceDescriptionIcon;